/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { MeshStandardMaterial } from 'three';
import { CapNames } from '../CapNames';
import { Fonts } from './Text3D/Fonts';
import { Orientation } from '../Orientation';
/**
 * Capability to draw 3D Texts
 * Note: for a better experience use Text2D
 */
export class Text3DCap {
    getName() {
        return CapNames.TEXT3D;
    }
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (payload.text) {
            const obj = Fonts.create3DText(payload.text, 0.1, new MeshStandardMaterial());
            obj.name = objectIn.name;
            Orientation.set(obj, objectIn);
            sceneIn.add(obj);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=Text3DCap.js.map